import { Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { SubmissionComponent } from './submission/submission.component';
import { PrivacyComponent } from './privacy/privacy.component';

const routes: Routes = [
    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'submission',
        component: SubmissionComponent
    },
    {
        path: 'privacy',
        component: PrivacyComponent
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    }
];

export { routes };
